import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44b09c6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white-50 p-4 mb-3 rounded-4 align-items-center" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "w-100 row mb-4 pb-4 border-bottom px-0" }
const _hoisted_4 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "search-container position-relative" }
const _hoisted_7 = ["placeholder", "maxlength"]
const _hoisted_8 = { class: "w-100 row mb-4 pb-4 border-bottom px-0" }
const _hoisted_9 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "search-container position-relative" }
const _hoisted_12 = ["placeholder", "maxlength"]
const _hoisted_13 = { class: "w-100 row mb-4 pb-4 border-bottom px-0" }
const _hoisted_14 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "search-container position-relative" }
const _hoisted_17 = ["placeholder", "maxlength"]
const _hoisted_18 = { class: "w-100 row pb-4 mb-4 border-bottom px-0" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 col-form-label margin-left pe-0" }, null, -1))
const _hoisted_20 = { class: "col-lg-6" }
const _hoisted_21 = { class: "form-check" }
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "d-flex align-items-center justify-content-center" }

import { translate } from '@/languages/i18n'
import { ref } from 'vue-demi'
import { useRoute, useRouter } from 'vue-router'
import { omit, throttle } from 'lodash'
import { WAITING_SUBMIT_TIME_OUT, MAX_LENGTH_TITLE_SEARCH, MAX_LENGTH_USER_NAME_SEARCH, MAX_LENGTH_POST_CONTENT } from '@/constants/number'
import Button from '@/components/button/index.vue'
import { onMounted, watch } from 'vue'
import { USER_POST_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  userPost: Boolean,
},
  setup(__props) {

const published = ref<boolean>(false)
const store = useStore()
const router = useRouter()
const route = useRoute()

const title = ref<string>(route.query?.title ?? '')
const content = ref<string>(route.query?.content ?? '')
const user_name = ref<string>(route.query?.user_name ?? '')



const handleSearch = throttle(() => {
  // 2022/09/15 CW-Phuong Fix for horizontal fixing#7: CT10, OF10
  if (checkRouter()) {
    if (route.path.match('/operational_posts')) {
      store.dispatch(USER_POST_STORE.ACTIONS.GET_OPERATIONAL_POST, {
        chatroom_id: route.params.id,
        params: { ...route.query, page_of_number: route.query?.page_of_number || 30 },
      })
    } else {
      store.dispatch(USER_POST_STORE.ACTIONS.GET_POST, {
        chatroom_id: route.params.id,
        params: { ...route.query, page_of_number: route.query?.page_of_number || 30 },
      })
    }
    return
  }
  let queryObj = { ...route?.query, published: published.value ? '' : true, page: '1' }
  queryObj = { ...queryObj, title: title.value, content: content.value, user_name: user_name.value }

  Object.keys(queryObj).forEach((e) => {
    if (queryObj[e] === '') {
      queryObj = omit(queryObj, e)
    }
  })

  router.push({ path: route.path, query: queryObj })
}, WAITING_SUBMIT_TIME_OUT)

// 2022/09/12 CW-Phuong Fix for horizontal fixing#7: CT10, OF10
onMounted(() => {
  if (!route?.query?.published) {
    published.value = true
  } else {
    published.value = false
  }
})
watch(
  () => route.query,
  () => {
    title.value = route.query.title ?? ''
    content.value = route.query.content ?? ''
    user_name.value = route.query.user_name ?? ''
    published.value = route.query.published ? false : true
  }
)
const checkRouter = () => {
  let titleInput = route.query.title ?? ''
  let contentInput = route.query.content ?? ''
  let user_name_input = route.query.user_name ?? ''
  let publishedInput = route.query.published ? false : true
  if (title.value === titleInput && content.value === contentInput && user_name.value === user_name_input && published.value === publishedInput) return true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleSearch) && _unref(handleSearch)(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)('title')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: _unref(translate)('placeholder'),
                class: "form-control w-100 position-absolute",
                onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"])),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((title).value = $event)),
                maxlength: _unref(MAX_LENGTH_TITLE_SEARCH)
              }, null, 40, _hoisted_7), [
                [
                  _vModelText,
                  title.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)('content')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: _unref(translate)('placeholder'),
                class: "form-control w-100 position-absolute",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"])),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((content).value = $event)),
                maxlength: _unref(MAX_LENGTH_POST_CONTENT)
              }, null, 40, _hoisted_12), [
                [
                  _vModelText,
                  content.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(translate)('creator')), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: _unref(translate)('placeholder'),
                class: "form-control w-100 position-absolute",
                onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"])),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user_name).value = $event)),
                maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH)
              }, null, 40, _hoisted_17), [
                [
                  _vModelText,
                  user_name.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", {
                class: "form-check-label",
                for: published.value
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input me-3",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((published).value = $event)),
                  type: "checkbox",
                  value: "",
                  id: published.value
                }, null, 8, _hoisted_23), [
                  [_vModelCheckbox, published.value]
                ]),
                _createTextVNode(" " + _toDisplayString(_unref(translate)('privatePostNew')), 1)
              ], 8, _hoisted_22)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(Button, {
            title: _unref(translate)('CI10search'),
            type: 'secondary',
            htmlType: 'submit'
          }, null, 8, ["title"])
        ])
      ])
    ], 32)
  ]))
}
}

})